import React from "react"
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

export default function Message({messageText}){
  const {t} = useTranslation();


  return (
    <Grid item xs sx={{paddingTop: 2.5, paddingBottom: 2.5}} className="d-f jc-c bg-primary3-color font-1-heavy white-color h5 left-slot right-slot">
        {t(messageText)}
    </Grid>
    )
}